import React, { useEffect, useState } from "react";
import { portalFetchRecurring } from "../../services/portalApi";
import PortalShell from "./PortalShell";
import "./portal.css";

const formatDate = (d) => {
  if (!d || d === "0000-00-00") return "—";
  try {
    return new Date(`${d}T12:00:00`).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

export default function PortalRecurring() {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const rows = await portalFetchRecurring();
        if (active) setSchedules(rows);
      } catch {
        if (active) setSchedules([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <PortalShell
      title="Upcoming charges"
      subtitle="Recurring invoice schedules linked to your account."
    >
      {loading ? (
        <p className="portal-empty">Loading schedules…</p>
      ) : schedules.length === 0 ? (
        <div className="portal-empty">No active recurring schedules on your account.</div>
      ) : (
        schedules.map((row) => (
          <article key={row.id} className="portal-card">
            <div className="portal-card__row">
              <div>
                <h2 className="portal-card__title">{row.template_name}</h2>
                <p className="portal-card__meta">
                  {row.frequency_label}
                  {row.next_run_date ? ` · Next ${formatDate(row.next_run_date)}` : ""}
                </p>
              </div>
              <span
                className={`portal-badge ${
                  row.status === "paused" ? "portal-badge--due" : "portal-badge--paid"
                }`}
              >
                {row.status === "paused" ? "Paused" : "Active"}
              </span>
            </div>
            <p className="portal-card__meta" style={{ marginTop: "0.65rem", fontWeight: 650 }}>
              Expected amount: {row.formatted_amount}
            </p>
            {row.end_date ? (
              <p className="portal-card__meta">Ends {formatDate(row.end_date)}</p>
            ) : null}
          </article>
        ))
      )}
    </PortalShell>
  );
}
